import {apiUrl} from "@/env";
import {getTokenHeaders} from "./api-utils";
import axios from "axios";
import {USER_ID, requestOptions} from "./shared-api-constants";

export const userUploadsApi = {
    async getDocumentsTypes() {
        requestOptions["headers"] = getTokenHeaders();
        const response = await axios.get(`${apiUrl}/api/v1/user-uploads/lookup/document-types`, requestOptions);
        return response;
    },
    async saveUserUploadsDocument(payload) {
        requestOptions['headers'] = getTokenHeaders()
        requestOptions['headers']['Content-Type'] = "multipart/form-data"
        const userId = sessionStorage.getItem(USER_ID)
        const response = await axios.post(`${apiUrl}/api/v1/user-uploads/advisor/${userId}/upload`, payload, requestOptions);
        return response;
    },
    async deleteUserUploadsDocument(payload) {
        requestOptions['headers'] = getTokenHeaders();
        const userId = sessionStorage.getItem(USER_ID);
        const response = await axios.post(`${apiUrl}/api/v1/user-uploads/advisor/${userId}/delete`, payload, requestOptions);
        return response;
    }
}